import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import CreatePortal from "@/components/CreatePortal/CreatePortal.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import {
  normalize_organization_profile,
} from "@/utils/organization_profile";
import {
  get_organization_setup_items,
  get_organization_setup_progress,
} from "@/utils/organization_setup_progress";
import {
  get_branding_style,
  homeFilterMethods,
  html_to_plain_text,
} from "./organisation_helpers";
import { HOME_FEATURE_ICONS } from "@/utils/home_feature_icons";

export default {
  components: {
    HomeNavBar,
    CreatePortal,
    StickyNav,
    InactivityModal,
  },
  data: () => ({
    token_exists: false,
    user_details: {},
    active_profile: null,
    saved_branding: null,
    recent_activities: [],
    company: {},
    quick_actions: [
      {
        action: "setup_dynamic_forms",
        icon: HOME_FEATURE_ICONS.dynamic_forms,
        title: "Set up Dynamic Forms",
        description: "Create in order: Question -> Section -> Form",
      },
      {
        action: "create_post",
        icon: HOME_FEATURE_ICONS.post,
        title: "Feed",
        description: "Create announcements for your organisation",
      },
      {
        action: "open_create_portal_modal",
        icon: HOME_FEATURE_ICONS.portals,
        title: "Portal",
        description: "Manage your organisation's portals",
      },
      {
        action: "create_event",
        icon: HOME_FEATURE_ICONS.events,
        title: "Events",
        description: "View, create, and manage events",
      },
      {
        action: "create_discussion",
        icon: HOME_FEATURE_ICONS.your_voice,
        title: "Discussion",
        description: "Start or manage organisation discussions",
        permission: "discussions",
      },
      {
        action: "manage_members",
        icon: HOME_FEATURE_ICONS.personal_profile,
        title: "Organisation Members",
        description: "Manage people connected to your organisation",
      },
      {
        action: "manage_payment_account",
        icon: HOME_FEATURE_ICONS.donations,
        title: "Payment Account",
        description: "Configure PayFast payment credentials",
      },
      {
        action: "manage_section_18a",
        icon: HOME_FEATURE_ICONS.section_18a,
        title: "Section 18A",
        description: "Manage your Section 18A details",
      },
      {
        action: "manage_membership_plans",
        icon: HOME_FEATURE_ICONS.memberships,
        title: "Membership Plans",
        description: "Manage your plan, benefits, and membership status",
      },
      {
        action: "manage_incidents",
        icon: HOME_FEATURE_ICONS.incident_reporting,
        title: "Incident Management",
        description: "Manage reported incidents, statuses, and follow-ups",
      },
      {
        action: "go_to_manage_incident_type",
        icon: HOME_FEATURE_ICONS.tags,
        title: "Manage Incident Type",
        description: "Configure incident types and assign responsible users",
      },
    ],
  }),
  computed: {
    branding_style() {
      return get_branding_style(this.saved_branding);
    },
    organization() {
      return normalize_organization_profile(
        this.company || {},
        this.user_details,
        this.saved_branding
      );
    },
    company_description() {
      return html_to_plain_text(this.company?.description);
    },
    profile_completion() {
      return get_organization_setup_progress(
        this.company || {},
        this.user_details || {}
      ).percent;
    },
    setup_items() {
      return get_organization_setup_items(
        this.company || {},
        this.user_details || {}
      );
    },
  },
  mounted() {
    this.token_exists = !!get_token();
    this.user_details = get_user_details() || {};
    this.saved_branding = this.get_saved_branding();
    this.apply_branding_to_platform(this.saved_branding);

    this.$nextTick(() => {
      this.fetch_company_profile();
    });

    window.addEventListener(
      "organization-branding-updated",
      this.handle_organization_branding_updated
    );
    window.addEventListener(
      "organization-profile-updated",
      this.handle_organization_profile_updated
    );
  },
  beforeUnmount() {
    window.removeEventListener("organization-branding-updated", this.handle_organization_branding_updated);
    window.removeEventListener("organization-profile-updated", this.handle_organization_profile_updated);
  },
  methods: {
    ...homeFilterMethods,
    handle_quick_action(action) {
      const quick_action_handlers = {
        setup_dynamic_forms: this.setup_dynamic_forms,
        create_post: this.create_post,
        open_create_portal_modal: this.open_create_portal_modal,
        create_event: this.create_event,
        create_discussion: this.create_discussion,
        manage_members: this.manage_members,
        manage_payment_account: this.manage_payment_account,
        manage_membership_plans: this.manage_membership_plans,
        manage_incidents: this.manage_incidents,
        go_to_manage_incident_type: this.go_to_manage_incident_type,
        manage_section_18a: this.manage_section_18a,
      };
      const handler = Reflect.get(quick_action_handlers, action);

      if (typeof handler === "function") {
        handler.call(this);
      }
    },
  },
};
